export default "__VITE_ASSET__583eb3ac__"